import { styled } from '@mui/material/styles';
import { InfoPageTitle } from 'views/common/components';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.down('lg')]: {
    paddingBottom: theme.spacing(3),
  },
  [theme.breakpoints.down('md')]: {
    paddingBottom: theme.spacing(2),
  },
}));

export const StyledInfoPageTitle = styled(InfoPageTitle)(({ theme }) => ({
  '& .IVHSButtonContiner': {
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
}));
export default StyledBox;
